<template>
  <wa-page
    :is-showing-bandana="false"
    :is-showing-sitewide-modal="false"
  >
    <wa-page-header
      slot="header"
      key="header"
    />

    <main
      slot="content"
      role="main"
      class="app-content"
    >
      <hero
        :last-updated="lastUpdated"
        :last-updated-formatted="lastUpdatedFormatted"
      />

      <div class="container padding-y-7xl">
        <div class="row roomy align-stretch margin-bottom-2xl laptop:margin-bottom-4xl">
          <div class="display-none laptop:display-block laptop:margin-bottom-0 laptop:column-3 laptop:offset-1">
            <in-page-nav />
          </div>

          <div class="column-12 laptop:column-8 laptop:order-first">
            <faqs />
            <cdn-providers />
            <payment-processors />
            <other-services />
            <contact />
            <changes
              :last-updated="lastUpdated"
              :last-updated-formatted="lastUpdatedFormatted"
            />
            <dpf-details />
          </div>
        </div>

        <sock slot="sock" />
      </div>
    </main>

    <wa-page-footer slot="footer" />
  </wa-page>
</template>

<script>
  import moment from 'moment'
  import CdnProviders from './sections/CdnProviders'
  import Changes from './sections/Changes'
  import Contact from './sections/Contact'
  import Faqs from './sections/Faqs'
  import Hero from './sections/Hero'
  import InPageNav from './sections/InPageNav'
  import OtherServices from './sections/OtherServices'
  import PaymentProcessors from './sections/PaymentProcessors'
  import Sock from './sections/Sock'
  import DpfDetails from './sections/DpfDetails'

  export default {
    name: 'PrivacyPolicyView',

    components: {
      CdnProviders,
      Changes,
      Contact,
      Faqs,
      Hero,
      InPageNav,
      OtherServices,
      PaymentProcessors,
      Sock,
      DpfDetails
    },

    data() {
      return {
        lastUpdated: '2024-11-11'
      }
    },

    computed: {
      lastUpdatedFormatted() {
        return moment(this.lastUpdated).format('LL')
      }
    }
  }
</script>
